import { Collection } from '@nozbe/watermelondb';

import { DBServiceOptionsWithImagesAndValidation } from '../../../../types/dbService';
import {
    ParsedShoppingListProduct,
    ShoppingListModel,
    ShoppingListPayload,
} from '../../../../types/ShoppingList';
import { ShoppingListProductModel } from '../../../../types/ShoppingListProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import Organisation from '../../Organisation';
import ShoppingListProduct from '../../ShoppingListProduct';

export const prepareCreateShoppingList = ({
    payload,
    userId,
    organisationID,
    collection,
}: {
    payload: ShoppingListPayload;
    userId: string;
    organisationID: string;
    collection: Collection<ShoppingListModel>;
}) =>
    collection.prepareCreate((shoppingList) => {
        shoppingList.userId = userId;
        shoppingList.organisationId = organisationID;
        shoppingList.name = payload.name;
        shoppingList.addedToInventoryTime = payload.addedToInventoryTime;
        shoppingList.sentToDealerTime = payload.sentToDealerTime;
        shoppingList.dealerId = payload.dealerId;
    });

export const prepareAddShoppingListProducts = async ({
    shoppingList,
    shoppingListProducts,
    userId,
    serviceOptions,
}: {
    shoppingList: ShoppingListModel;
    shoppingListProducts: ParsedShoppingListProduct[];
    userId: string;
    serviceOptions: DBServiceOptionsWithImagesAndValidation;
}) => {
    if (!shoppingList || shoppingListProducts.length === 0) return [];

    const organisationService = new Organisation(serviceOptions);
    const shoppingListProductsService = new ShoppingListProduct(serviceOptions);

    const organisation = await organisationService.get();
    const { id: organisationID } = organisation[0];

    return shoppingListProductsService.prepareAdd(
        shoppingListProducts,
        shoppingList.id,
        userId,
        organisationID,
    );
};

export const logAddShoppingListActions = ({
    shoppingList,
    shoppingListProductsToAdd,
    logDBAction,
    tableName,
}: {
    shoppingList: ShoppingListModel;
    shoppingListProductsToAdd: ShoppingListProductModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create shopping list',
        modelName: tableName,
        payload: shoppingList,
    });

    if (shoppingListProductsToAdd.length > 0) {
        logDBAction({
            message: 'Create shopping list - create shopping list products',
            modelName: tableName,
            payload: shoppingListProductsToAdd,
        });
    }
};
